import {IconCalendar, IconFolder} from "@tabler/icons-react";
import {Group, Text} from "@mantine/core";
import {useContext, useEffect, useState} from "react";
import QRCodeDetailsContext from "../../../QRCodeDetailsContext";
import dayjs from "dayjs";

type CreatedSmallBadgeProps = {};

function CreatedSmallBadge(props: CreatedSmallBadgeProps) {
    const ctx = useContext(QRCodeDetailsContext);

    const [createdAt, setCreatedAt] = useState<string>();

    /**
     * Reload created at.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const reload = () => {
        const dt = ctx.qrCode?.createdAt;

        setCreatedAt(
            dayjs(dt).format("YYYY-MM-DD HH:mm:ss")
        );
    };

    useEffect(reload);

    if (!createdAt) {
        return null;
    }

    return (
        <Group gap="0.3rem" justify="left" align="center">
            <IconCalendar
                size="1.01rem"
                color="rgba(83, 103, 140, 100)"
            />

            <Text
                c="rgba(83, 103, 140, 100)"
                children={createdAt}
                size="sm"
            />
        </Group>
    );
}

export default CreatedSmallBadge;